import React from 'react';
import './style.scss';
import { icons } from 'constants/icons';
import { IconColor, IconSize, SvgIcon } from '../svgIcon';

type SearchBoxProps = {
  searchWord?: string;
  setSearchWord: (searchWord: string) => void;
  submitSearch: (searchWord: string) => void;
  clearSearch: () => void;
  placeholder?: string;
};

export const SearchBox = (props: SearchBoxProps) => {
  const { searchWord, setSearchWord, submitSearch, placeholder, clearSearch } = props;

  return (
    <div className="searchBox">
      <input
        className="searchBox_input"
        type="search"
        inputMode="search"
        value={searchWord}
        onChange={(e) => setSearchWord(e.target.value)}
        placeholder={placeholder}
      />
      {/* cssのwebkitでブラウザデフォルトのxボタンは非表示にした状態でxの画像を配置している */}
      <button className="searchBox_cancelIcon" onClick={clearSearch}>
        {searchWord && <img src={icons.cancel} alt="icon" />}
      </button>
      <div
        className="searchBox_iconWrapper"
        onClick={() => {
          submitSearch(searchWord || '');
        }}
      >
        <button className="searchBox_icon">
          <SvgIcon icon={icons.search} color={IconColor.white} size={IconSize.icon_s} />
        </button>
      </div>
    </div>
  );
};
